import React from "react";
import PropTypes from "prop-types";

const ImgWithFallback = ({ src, fallback, type, alt, ...rest }) => (
  <picture>
    <source srcSet={src} type={type} />
    <img src={`/minifiedImages/${fallback}`} {...rest} alt={alt} />
  </picture>
);

ImgWithFallback.propTyeps = {
  src: PropTypes.string.isRequired,
  fallback: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

ImgWithFallback.defaultProps = {
  type: "image/webp",
};

export default ImgWithFallback;
